import { filter } from 'lodash';
import React, { useState } from 'react';

import { Box, Link, Stack } from '@fhs-legacy/universal-components';
import { useAnchorContext } from 'utils/static-page/hooks/useAnchorContext';

const AnchorLinks = Stack.withConfig({
  alignItems: 'center',
  direction: {
    base: 'column',
    desktop: 'row',
  },
  space: '$4',
});

const AnchorLinkItem = Link.withConfig({
  isUnderlined: false,
});

const AnchorLinksDivider = Box.withConfig({
  width: '5/6',
  borderTopWidth: '2',
  borderTopColor: Styles.color.grey.five,
});

const AnchorLinksWidget = props => {
  const { scrollToTarget, formatLocaleAnchorName } = useAnchorContext();
  const [currentPressedLink, setcurrentPressedLink] = useState();
  const language = 'en';

  return (
    <>
      <AnchorLinks>
        <AnchorLinksDivider />
        {filter(props.widgets, ['_type', 'anchorWidget']).map(anchor => {
          const anchorName = anchor.anchorName?.[language];

          return (
            <AnchorLinkItem
              // href={`#${formatLocaleAnchorName(anchor.anchorName?.locale)}`} TODO: RN - ensure web/browser anchor navigation works
              key={anchor._key}
              isUnderlined={currentPressedLink === anchorName}
              onPress={() => {
                // TODO: RN move to a better place in the navigation/route handling logic? href/router currently creates exception when pressed
                setcurrentPressedLink(anchorName);
                scrollToTarget(formatLocaleAnchorName(anchorName));
              }}
            >
              {anchorName}
            </AnchorLinkItem>
          );
        })}
        <AnchorLinksDivider />
      </AnchorLinks>
    </>
  );
};

export default AnchorLinksWidget;
